import apiClient from './api';
import { BranchProfitLossReportDto } from '../types/reports.types';

export const reportsService = {
  // تقرير الربح والخسارة للفرع - يرجع object واحد
  getBranchProfitLoss: async (
    costCenterId: number | null,
    fromDate: string,
    toDate: string
  ): Promise<BranchProfitLossReportDto> => {
    const params = new URLSearchParams({
      fromDate: fromDate,
      toDate: toDate,
    });

    if (costCenterId !== null) {
      params.append('costCenterId', costCenterId.toString());
    }

    const response = await apiClient.get(`/Reports/BranchProfitLoss?${params.toString()}`);
    return response.data.data;
  },
};